import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type TMSTruckNumber = {
  id: number;
  truckNumber: string;
};

export type TMSTrailerNumber = {
  id: number;
  trailerNumber: string;
};

export async function getTruckNumbers(
  tmsID: number,
  carrierApplicationID: string
): Promise<Result<TMSTruckNumber[], ApiError>> {
  try {
    const response = await axios.get<TMSTruckNumber[]>(
      `/load/options/carrier/truck-numbers?tmsID=${tmsID}&carrierApplicationID=${carrierApplicationID}`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getTruckNumbers' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get list of truck numbers from TMS' });
    }

    return err({
      message:
        error.response?.data.message ||
        'Failed to get list of truck numbers from TMS',
    });
  }
}

export async function getTrailerNumbers(
  tmsID: number,
  carrierApplicationID: string
): Promise<Result<TMSTrailerNumber[], ApiError>> {
  try {
    const response = await axios.get<TMSTrailerNumber[]>(
      `/load/options/carrier/trailer-numbers?tmsID=${tmsID}&carrierApplicationID=${carrierApplicationID}`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getTrailerNumbers' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get list of trailer numbers from TMS' });
    }

    return err({
      message:
        error.response?.data.message ||
        'Failed to get list of trailer numbers from TMS',
    });
  }
}
